module.exports = {
  "country": "UA",
  "artist": "Jamala",
  "song": "1944",
  "year": "2016",
  "place": "1",
  "spotify": "1AZQTUs1FPy7YHH8aad3dA"
};